const overrideTableOptions = {
    target: 'table',
    sortProp: 'avg',
    displayLimit: 10,
    assignRowTo: 'county',
    include: {
        auxiliaryCols: ['rank', 'county'],
        data: ['rank', 'county', 'avg', 'cameras', 'potholes', 'speed', 'delay'],
        header: {
            'rank': '',
            'county': 'Place',
            'avg': new Element({
                element: 'img',
                attributions: {attribute: 'src', value: 'assets/img/Icon-total.svg'},
            }).returnElement(),
            'cameras': new Element({
                element: 'img',
                attributions: {attribute: 'src', value: 'assets/img/Icon-speedcamera.svg'}
            }).returnElement(),
            'potholes': new Element({
                element: 'img',
                attributions: {attribute: 'src', value: 'assets/img/Icon-pothole.svg'}
            }).returnElement(),
            'speed': new Element({
                element: 'img',
                attributions: {attribute: 'src', value: 'assets/img/Icon-speed.svg'}
            }).returnElement(),
            'delay': new Element({
                element: 'img',
                attributions: {attribute: 'src', value: 'assets/img/Icon-delays.svg'}
            }).returnElement(),

        },
        mobileControl: {
            titles: {
                'avg': 'Overall Frustration Score',
                'cameras': 'Speed Cameras',
                'potholes': 'Potholes',
                'speed': 'Slow Traffic',
                'delay': 'Delays',
            },
            listControlBtn: {
                text: 'Select Category',
                animation: {
                    effectIn: 'fadeIn',
                    durationIn: 300,
                    effectOut: 'fadeOut',
                    durationOut: 300,
                }
            }
        },
        toggleRowBtns: {
            showText: 'View More',
            hideText: 'View Less'
        }
    }
};

const table = new Table({data: data, rankHighToLow: true}, overrideTableOptions);
table.addBootstrapGridClasses({
    'col--rank': {
        xs: 2,
        sm: 1,
        md: 1,
        lg: 1,
        xl: 1
    },
    'col--county': {
        xs: 7,
        sm: 9,
        md: 3,
        lg: 4,
        xl: 2
    },
    'col--avg': {
        xs: 3,
        sm: 2
    },
    'col--cameras': {
        xs: 3
    },
    'col--potholes': {
        xs: 3
    },
    'col--speed': {
        xs: 3
    },
    'col--delay': {
        xs: 3
    },
});
table.wrapElement('mobileControlList', {element: 'span'}, 'all');
table.wrapElement('mobileControlBtn', {element: 'span'});
table.wrapElement('toggleRowBtn', {element: 'span'}, false);
table.wrapElement('header', {element: 'span'}, 'all');
table.wrapAllCols({
    element: 'a', attributions: [
        {attribute: 'data-toggle', value: 'popover'},
        {attribute: 'data-placement', value: 'left'},
        {attribute: 'data-trigger', value: 'focus'},
        {attribute: 'role', value: 'button'},
        {attribute: 'tabindex', value: '0'}
    ]
}, 'col--cameras col--potholes col--speed col--delay');
table.addAttributesToCols({attribute: 'data-type', value: 'cameras'}, 'col--cameras');
table.addAttributesToCols({attribute: 'data-type', value: 'potholes'}, 'col--potholes');
table.addAttributesToCols({attribute: 'data-type', value: 'speed'}, 'col--speed');
table.addAttributesToCols({attribute: 'data-type', value: 'delay'}, 'col--delay');

function setupPopover(self) {
    const location = $(self).parents('.table__row').attr('data-target');
    const dataType = $(self).parents('.table__col').attr('data-type');
    const data = rawData[dataType][location];
    console.log(" data = ", data);
    console.log(" dataType = ", dataType);
    console.log(" location = ", location);
    const prefix = (dataType === 'cameras') ? 'Total number of reported speed cameras' :
        (dataType === 'potholes') ? 'Total number of reported potholes' :
            (dataType === 'speed') ? 'Average speed on local A roads (Miles Per Hour)' :
                'Average delay on local A roads (Seconds Per Vehicle Per Mile)';

    $(self).popover({html: true, content: `<b>${prefix}:</b> ${data}`});
    $(self).popover('show');
}

$(document).on('click', '.table__col a', function ()
{
    setupPopover(this);
});

$(document).on('mouseenter', '.table__col a', function ()
{
    setupPopover(this);
    $(this).focus();
});

$(document).on('mouseleave', '.table__col a', function ()
{
    $('.table__col a').blur();
});


$(window).resize(function() {
    $('.table__col a').popover('dispose');
});

// ************************************</editor-fold>
// BOOTSTRAP
// ************************************<editor-fold>

$(function ()
{
    $('[data-toggle="tooltip"]').tooltip();
});




